import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  role: null,
  role_id: null,
  pg_id: null,
  phoneNumber: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.user = action.payload.user;
      state.role = action.payload.role;
      state.role_id = action.payload.role_id;
      state.pg_id = action.payload.pg_id;
      state.phoneNumber = action.payload.phoneNumber;
    },
    clearAuthData: (state) => {
      state.user = null;
      state.role = null;
      state.role_id = null;
      state.pg_id = null;
      state.phoneNumber = null;
    },
    updateTocAccepted(state) {
      if (state.user) {
        state.user.toc_accepted = true;
      }
    },
    updateUsername: (state, action) => {
      if (state.user) {
        state.user.username = action.payload.username;
      }
    },
    updateEmail: (state, action) => {
      if (state.user) {
        state.user.email = action.payload.email;
      }
    },
  },
});

export const { setAuthData, clearAuthData, updateUsername, updateTocAccepted, updateEmail } = authSlice.actions;

export default authSlice.reducer;
